import { CLASSIFICATION_CUBE_NAME } from '@/api/hcp';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';

const TAE_LEVELS_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.tae`],
  limit: undefined,
});

const taeLevelFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.taeLevelsLabel',
  sourceCube: CLASSIFICATION_CUBE_NAME,
  defaultValue: [],
  getOptionsQuery: TAE_LEVELS_OPTIONS,
  mapResult: mapDimensionToOption(`${CLASSIFICATION_CUBE_NAME}.tae`),
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.taeLevelsPlaceholder',
  format: ({ value }) => {
    const v = value as string;
    return v === 'other' ? 'Other' : v;
  },
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${CLASSIFICATION_CUBE_NAME}.tae`,
      operator: 'equals',
      values: [...v],
    };
  },
};

export default taeLevelFilter;
